define('modules/form_editor/views/editor_custom_date',['require','exports','module','base/view','../../editor/models/editorstate','jquery','ldsh!../templates/editor_custom_date'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/view"),
    EditorState = require("../../editor/models/editorstate"),
    $ = require('jquery');

  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_date"),

    events: {
      "change .js-date-order": "updateModel",
      "change .js-limit": "updateModel",
      "change .js-separator": "updateModel",
      "change .js-fill-zero": "updateModel"
    },

    initialize: function() {
      this.listenTo(this.model, "invalid", this.render);
    },

    helpers: function() {
      return {
        isDashedDate: this.model.get("separator") === "-",
        isAMP: EditorState.getAMPState()
      };
    },

    updateModel: function() {
      var modelParams = {
        dateOrder: $.trim(this.$(".js-date-order").val()),
        ageLimit: +this.$(".js-limit").val().trim(),
        separator: this.$(".js-separator").is(":checked") ? "-" : "/",
        fillWithZero: this.$(".js-fill-zero").is(":checked")
      };

      this.model.set(modelParams, { validate: true });
    },

    onRender: function() {
      var order = this.model.get("dateOrder");
      this.$("option[value='" + order + "']").attr("selected", true);
      this.$el.i18n();
    }
  });
});

